<template>
    <LegalAgreementPdfContent
        :content="legalAgreementContent"
        :variable-values="variableValues"
        :file-name="`legal-agreement-${agreementType}-${language}-${versionId}${fileNameSuffix}.pdf`"
    />
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useRoute} from '#imports';
    import type {LegalAgreementLanguage, LegalAgreementType} from '@api';
    import LegalAgreementPdfContent from '~/components/legal-agreements/LegalAgreementPdfContent.vue';
    import {useAdminLegalAgreementsStore} from '~/stores/admin-legal-agreements.store';
    import {sampleVariableValues} from '~/utils/legalAgreementVariables';

    const route = useRoute();
    const adminLegalAgreementsStore = useAdminLegalAgreementsStore();

    const agreementType = route.params.agreementType as LegalAgreementType;
    const versionId = route.params.versionId as string;
    const language = route.params.language as LegalAgreementLanguage;

    await adminLegalAgreementsStore.fetchVersionContent(agreementType, versionId, language);

    const {legalAgreementContent} = storeToRefs(adminLegalAgreementsStore);

    const variableValues = route.query.sample === 'true' ? sampleVariableValues(language) : undefined;
    const fileNameSuffix = variableValues ? '-sample' : '';
</script>
